var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSubcontractor(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 7L6 9M16 7L14 9M2 13V11.7143C2 8.08296 4.54955 5.03173 8 4.1666M18 13V11.7143C18 8.08296 15.4505 5.03173 12 4.1666M3 17H17C18.1046 17 19 16.1046 19 15C19 13.8954 18.1046 13 17 13H3C1.89543 13 1 13.8954 1 15C1 16.1046 1.89543 17 3 17ZM12 5V4C12 2.89543 11.1046 2 10 2C8.89543 2 8 2.89543 8 4V5C8 6.10457 8.89543 7 10 7C11.1046 7 12 6.10457 12 5Z",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubcontractor);
export default __webpack_public_path__ + "static/media/subcontractor.e476887c746d128b797d78c367fc05ab.svg";
export { ForwardRef as ReactComponent };